import cx from 'classnames';
import * as React from 'react';
import styles from './title-with-badge.module.scss';

type TitleWithBadgeProps = {
  children: React.ReactNode;
  className?: string;
  badgeText?: React.ReactNode;
};

export const TitleWithBadge = (props: TitleWithBadgeProps) => {
  return (
    <h2 className={cx('relative', props.className)}>
      {props.children}
      {props.badgeText && (
        <div className={styles.badgeContainer}>
          <div
            className={`text-base sm:text-xl lg:text-xl shadow bg-blue-700 text-gray-100 px-4 py-1 ${styles.badge}`}
          >
            {props.badgeText}
          </div>
        </div>
      )}
    </h2>
  );
};
